module.exports = __webpack_public_path__ + "static/media/image05.4791e324.jpeg";